import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

/**
 * Shared table column filter_params (JSON string) for dashboard chart/summary APIs.
 * Populated by Products / Order Items tables; consumed by useDashChartRows.
 */
const DashboardTableFilterContext = createContext(null);

export function DashboardTableFilterProvider({ children }) {
  const [filterParams, setFilterParams] = useState(null);

  const setTableFilterParams = useCallback((next) => {
    setFilterParams(next || null);
  }, []);

  const value = useMemo(
    () => ({ filterParams, setTableFilterParams }),
    [filterParams, setTableFilterParams]
  );

  return (
    <DashboardTableFilterContext.Provider value={value}>
      {children}
    </DashboardTableFilterContext.Provider>
  );
}

/** Returns null when used outside DashboardTableFilterProvider (e.g. Chart tab). */
export function useDashboardTableFilter() {
  return useContext(DashboardTableFilterContext);
}
